import { render, staticRenderFns } from "./memorandum.vue?vue&type=template&id=b3a956a0&scoped=true"
import script from "./memorandum.vue?vue&type=script&lang=js"
export * from "./memorandum.vue?vue&type=script&lang=js"
import style0 from "./memorandum.vue?vue&type=style&index=0&id=b3a956a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3a956a0",
  null
  
)

export default component.exports